<div class="files-upload-container flex flex-col">
  <!-- loader element is always invisible -->
  <input #fileUploadInput class="file-input" data-test-id="file-upload-input" type="file" />
  @if (!file) {
    <div class="flex flex-col flex-center-start">
      <button
        (click)="fileUploadInput.click()"
        class="add-file-btn"
        color="primary"
        data-test-id="file-upload-addFileBtn"
        mat-button
        type="button"
      >
        Add file
      </button>
    </div>
  }
  @if (file) {
    <file-upload-element [blobUrl]="blobUrl" [file]="file" (removeFile)="reset()"></file-upload-element>
  }
</div>
